
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.83 17.55h5.633c.507-4.817 4.598-8.58 9.547-8.58 5.29 0 9.6 4.31 9.6 9.6s-4.31 9.6-9.61 9.6a9.643 9.643 0 01-3.907-.83L26.5 42.222v9.508h3.94c.55 0 1 .45 1 1s-.44 1-1 1h-9.88c-.55 0-1-.45-1-1s.45-1 1-1h3.94v-9.525L11.14 19.05a.994.994 0 010-1c.18-.31.51-.5.87-.5h9.48L16.31 9H12c-.55 0-1-.45-1-1s.45-1 1-1h4.87c.35 0 .67.18.86.48l6.1 10.07zm-.566 2h7.005a.996.996 0 00.282 0h6.719l-1.234 2.138c-1.192.466-5.019 1.003-10.676.032-2.9-.502-6.466-.2-9.901.809L13.74 19.55h9.524zm-6.775 4.764L25.5 39.93l9.17-15.875c-2.332.334-5.754.303-9.65-.365-2.442-.423-5.553-.186-8.531.624zm22.52-6.764h-7.532c.497-3.706 3.686-6.58 7.533-6.58 4.19 0 7.6 3.41 7.6 7.6 0 4.19-3.41 7.6-7.6 7.6a7.628 7.628 0 01-2.91-.575l3.78-6.545c.18-.31.18-.69 0-1-.18-.31-.51-.5-.87-.5z"}})])
          )
        }
      }
    